import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { motion } from "framer-motion";
import {
  Award,
  Laptop,
  ClipboardCheck,
  Book,
  Globe,
  CollectionPlay,
} from "react-bootstrap-icons";

const features = [
  {
    icon: <ClipboardCheck size={40} />,
    title: "Professional Instruction",
    text: "Get guidance from industry experts with years of teaching experience.",
  },
  {
    icon: <Award size={40} />,
    title: "Certified Courses",
    text: "Earn globally recognized certifications to boost your career.",
  },
  {
    icon: <Laptop size={40} />,
    title: "Learn Courses Online",
    text: "Study anytime, anywhere with our flexible online learning platform.",
  },
  {
    icon: <CollectionPlay size={40} />,
    title: "5000+ Online Courses",
    text: "Access thousands of courses across various domains and skills.",
  },
  {
    icon: <Book size={40} />,
    title: "Free Online Ebooks",
    text: "Get free study materials and ebooks to support your learning.",
  },
  {
    icon: <Globe size={40} />,
    title: "Global Location",
    text: "Join a worldwide learning community with global accessibility.",
  },
];

const WhyChooseUs = () => {
  return (
    <div className="why-choose-us-section py-5">
      <Container>
        {/* Section Title */}
        <motion.div
          initial={{ opacity: 0, y: -50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-5"
        >
          <h2 className="fw-bold">
            Why To Choose Us
          </h2>
          <div
            style={{
              width: "60px",
              height: "3px",
              backgroundColor: "#F89A33",
              margin: "10px auto",
            }}
          ></div>
          <p className="text-muted">
            Get many features from us exactly what you are looking for.
          </p>
        </motion.div>

        {/* Cards Section */}
        <Row className="gy-4">
          {features.map((feature, index) => (
            <Col key={index} xs={12} md={6} lg={4}>
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                // transition={{ duration: 0.6, delay: index * 0.2 }}
                whileHover={{ scale: 1.05 }}
                className="h-100"
              >
                <Card className="shadow-sm border-0 text-center p-4 h-100">
                  <div className="about-text mb-3">{feature.icon}</div>
                  <Card.Title className="fw-bold">{feature.title}</Card.Title>
                  <Card.Text className="text-muted">{feature.text}</Card.Text>
                </Card>
              </motion.div>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default WhyChooseUs;
